import { myTabId } from '@/services/myTabId'
import { getAllExtensionControllers } from '@/services/extensionControllers'
import {
  OauthEnabledProviders,
  OauthProviderLabels,
} from '@learnics/models/src/utils/oauthConfig.mjs'

export function createLoginArguments(
  state,
  user,
  scopes = null, // The scopes to request, defaults to the default scopes for the provider
  prompt = 'none', // We always default to none.  If that fails, the popup will automatically upgrade to select_account.  If that fails, the call will be tried once more with "consent".
  redirect = false,
  linkingGoogleAccount = false,
  showWarning = false,
  warningMessage = '',
  redirectUrl = null,
  providerId = null, // The provider ID to use for the OAuth login, leave null to allow for a choice
) {
  if (!providerId && OauthEnabledProviders.length === 1) {
    // If there's only one provider enabled (google), use that one
    providerId = OauthEnabledProviders[0]
  }
  if (!providerId) {
    showWarning = true
  }
  warningMessage ||= `Please sign in ${providerId ? 'with ' + OauthProviderLabels[providerId] : ''} to continue.`
  const extensions = getAllExtensionControllers().filter(
    (extension) => extension.manifest,
  )
  let extensionId, tabId, messages
  if (extensions.length > 0) {
    tabId = myTabId.get()
    console.warn('Creating login arguments with tab ID ' + tabId)
    // If we have at least one extension connected, let it take over the login process
    extensionId = extensions[0].extensionId
    messages = [
      {
        action: 'sendMessageToLearnicsWebApp',
        tabId: tabId,
        message: {
          action: 'loginSuccess',
        },
      },
    ]
  }
  let providerUid = null
  for (let i = 0; providerId && i < user?.providerData?.length; i++) {
    const provider = user?.providerData?.[i]
    if (provider.providerId === providerId) {
      providerUid = provider.uid
      break
    }
  }

  return {
    scope: scopes,
    prompt,
    state: {
      uid: user?.uid || null,
      ...(redirect
        ? {
            base64RedirectUrl: btoa(redirectUrl || window.location.href),
          }
        : {}),
      tabId, // This is the tab ID we're logging in for.  Possibly null.
      extensionId, // This is the extensionId that is handling the login.  Possibly null.
      messages, // Messages to execute after login.  Possibly null or empty.
      linkingGoogleAccount: !!linkingGoogleAccount, // Whether or not this auth flow will just link the account or not.
      ...(showWarning && warningMessage
        ? {
            showWarning: true,
            warningMessage: warningMessage,
          }
        : {}),
      ...(state || {}),
    },
    login_hint: providerUid || user?.email || null,
    include_granted_scopes: true,
    access_type: 'offline',
  }
}
